import React, { useEffect, useState } from 'react';
import Footer from '../../../components/Footer/Footer';
import InnerNav from '../../../components/InnerNav/InnerNav';
import Zodiac from '../../../components/ZodiacSign/Zodiac';
import './SankrantiDates.scss';
import VratLinks from '../../../components/VratLinks/VratLinks';
import axios from 'axios';
import city from '../../../city.json'


const formatTime = (str, format = '12hr') => {
  if (typeof str !== 'string') return '--';
  const match = str.match(/(\d{1,2}):(\d{2})\s*(AM|PM)?/i);
  if (!match) return str;

  let [_, hh, mm, period] = match;
  let hours = parseInt(hh, 10);
  const minutes = parseInt(mm, 10);

  if (format === '24hr' || format === '24hr+') {
    if (period?.toUpperCase() === 'PM' && hours !== 12) hours += 12;
    if (period?.toUpperCase() === 'AM' && hours === 12) hours = 0;
    const h = hours.toString().padStart(2, '0');
    const m = minutes.toString().padStart(2, '0');
    return `${h}:${m}${format === '24hr+' ? ':00' : ''}`;
  } else {
    let suffix = period || (hours >= 12 ? 'PM' : 'AM');
    if (hours === 0) hours = 12;
    if (hours > 12) hours -= 12;
    return `${hours}:${mm} ${suffix.toUpperCase()}`;
  }
};

const SankrantiDates = () => {
  const [year, setYear] = useState(2025);
  const [location, setLocation] = useState('kolkata');
  const [timeFormat, setTimeFormat] = useState('12hr');
  const [sankrantiList, setSankrantiList] = useState([]);

  const [popupFestival, setPopupFestival] = useState(null);
   const [tempLocation, setTempLocation] = useState("Kolkata");
  const [suggestions, setSuggestions] = useState([]);
  const [selectedSankranti, setSelectedSankranti] = useState(null);


const festivalDetails = {
  "About 12 Sankranti": {
    name: "About 12 Sankranti",
    description: "In Hindu calendar, there are total twelve Sankranti in a year. All twelve Sankranti can be divided into four categories which are known as Ayan, Vishuva, Vishnupadi and Shadshitimukhi Sankranti.",
    significance: "Each Sankranti marks the Sun’s movement into a new zodiac sign. They are important markers in Vedic astrology and Hindu rituals.",
    culturalAspect: "While all Sankranti are considered auspicious for charity and spiritual practices, only a few like Makar Sankranti are celebrated widely with public festivals."
  },
  "Makar Sankranti": {
    name: "Makar Sankranti",
    description: "Makar Sankranti marks the Sun’s transition into the zodiac sign Capricorn (Makara). It usually falls on January 14th or 15th.",
    significance: "It signifies the end of winter solstice and the beginning of longer days, symbolizing light and knowledge over darkness.",
    culturalAspect: "It is celebrated across India with different names – Pongal in Tamil Nadu, Uttarayan in Gujarat, Magh Bihu in Assam, and Lohri in Punjab. Kite flying, bonfires, feasts, and holy river dips are common traditions."
  }
};


  const currentDate = new Date();
  const weekDay = currentDate.toLocaleDateString('en-US', { weekday: 'long' });
  const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  const readableDate = `${months[currentDate.getMonth()]} ${currentDate.getDate()}, ${currentDate.getFullYear()}`;

  const changeYear = (offset) => setYear((prev) => prev + offset);
  const handleYearInput = (e) => {
    const val = parseInt(e.target.value);
    if (!isNaN(val)) setYear(val);
  };

    const festivalTooltips = {
  "Lohri": "Lohri is a popular Punjabi festival marking the end of winter and the beginning of the harvest season. People gather around bonfires, sing traditional songs, and offer sesame seeds, jaggery, and popcorn.",
  "Maghi": "Maghi is celebrated in Punjab to honor the memory of the 40 Sikh martyrs. It is observed with religious gatherings and fairs at holy sites like Muktsar Sahib.",
  "Bhogi Pandigai": "Bhogi Pandigai is the first day of Pongal in Tamil Nadu, where old belongings are discarded and bonfires are lit, symbolizing transformation and new beginnings.",
  "Makara Sankranti": "Makara Sankranti marks the sun’s transition into Capricorn. It signifies the beginning of longer days and is celebrated with kite flying, feasts, and holy dips in rivers.",
  "Pongal": "Pongal is a Tamil harvest festival thanking the Sun God. A special dish called 'Pongal' is cooked with newly harvested rice, milk, and jaggery.",
  "Pedda Panduga": "Pedda Panduga is a traditional Telugu harvest festival where families reunite, perform rituals, and enjoy special dishes.",
  "Uttarayana": "Uttarayana marks the beginning of the sun’s northward journey. It's considered an auspicious period in Hindu tradition.",
  "Uruka": "Uruka is the eve of Magh Bihu in Assam, where communities feast together and prepare for the main Bihu celebrations.",
  "Mattu Pongal": "Mattu Pongal is a day dedicated to honoring cattle in Tamil Nadu. Cows and bulls are decorated, fed, and worshipped for their role in farming.",
  "Kanuma Panduga": "Kanuma Panduga is celebrated in Andhra Pradesh, where farmers honor their cattle and showcase them in village processions.",
  "Magh Bihu": "Magh Bihu, also known as Bhogali Bihu in Assam, is a harvest festival marked by feasting, bonfires, and community gatherings.",
  "Kaanum Pongal": "Kaanum Pongal is the final day of Pongal in Tamil Nadu. Families go on outings and pay respects to elders with blessings and gifts.",
  "Mukkanuma": "Mukkanuma is celebrated in Andhra Pradesh to worship nature, especially cattle and tools used in farming. It marks the end of the three-day Sankranti festival."
};

  useEffect(() => {
    const fetchSankranti = async () => {
      try {
        const res = await axios.get(
          `https://core-c343.onrender.com/api/sankranti-region?year=${year}&location=${encodeURIComponent(location)}`
        );
        if (res.data && Array.isArray(res.data.months)) {
          setSankrantiList(res.data.months);
        } else {
          setSankrantiList([]);
        }
      } catch (error) {
        console.error('Failed to fetch Sankranti data:', error);
        setSankrantiList([]);
      }
    };

    fetchSankranti();
  }, [year, location]);


    const handleChange = (e) => {
      const value = e.target.value;
      setTempLocation(value);
  
      // filter cities when user types
      if (value.length > 0) {
        const filtered = city.filter((c) =>
          c.city.toLowerCase().includes(value.toLowerCase())
        );
        setSuggestions(filtered.slice(0, 4)); // show only first 4 results
      } else {
        setSuggestions([]);
      }
    };
  
const handleSelect = (cityName) => {
  setTempLocation(cityName);
  setLocation(cityName); // 🔥 REQUIRED
  setSuggestions([]);
};



  return (
    <div className="SankrantiDates-container">
      <InnerNav />
      <div className="SankrantiDates-content">
        <Zodiac />

        <div className="calendarr-wrapper">
          <div className="calendar-header dark">
            <div className="highlight">
              <h2>{year} Sankranti Dates</h2>
              <div className="current-ekadashi">
                <img
                  src="https://static.toiimg.com/thumb/msid-117223167,width-400,resizemode-4/117223167.jpg"
                  alt="Sankranti"
                  className="moon-preview"
                />
                <div>
                  <p><strong>{location}</strong></p>
                </div>
                <div className="current-date">
                  <p><strong>{currentDate.getDate()}</strong></p>
                  <p>{readableDate}</p>
                  <p>{weekDay}</p>
                </div>
              </div>

              <div className="san-controls">
                 <div className="input-with-icon">
                  <span className="icon">📍</span>
                  <input
                    type="text"
                    value={tempLocation}
                    onChange={handleChange}
                    placeholder="Enter location"
                  />
                  {suggestions.length > 0 && (
                    <ul className="dropdown">
                      {suggestions.map((c, idx) => (
                        <li key={idx} onClick={() => handleSelect(c.city)}>
                          {c.city}, {c.state}, {c.country}
                        </li>
                      ))}
                    </ul>
                  )}
                  </div>
                <input type="number" value={year} onChange={handleYearInput} />
                <button onClick={() => changeYear(-1)}>Prev Year</button>
                <button onClick={() => setYear(new Date().getFullYear())}>Current Year</button>
                <button onClick={() => changeYear(1)}>Next Year</button>
                <div className="clock-modes">
                  <button className={timeFormat === '12hr' ? 'active' : ''} onClick={() => setTimeFormat('12hr')}>12 Hour</button>
                  <button className={timeFormat === '24hr' ? 'active' : ''} onClick={() => setTimeFormat('24hr')}>24 Hour</button>
                  <button className={timeFormat === '24hr+' ? 'active' : ''} onClick={() => setTimeFormat('24hr+')}>24 Plus</button>
                </div>
              </div>
            </div>
          </div>

{!selectedSankranti ? (
  <div className="sankranti-list">
    {sankrantiList.length === 0 && (
      <p>No Sankranti data available for selected year/location.</p>
    )}

    {sankrantiList.map((item, index) => (
      <div
        className="sankranti-item clickable"
        key={index}
        onClick={() => setSelectedSankranti(item)}
      >
        <img
          src="https://static.toiimg.com/thumb/msid-117223167,width-400,resizemode-4/117223167.jpg"
          alt="Sankranti"
        />

        <div className="sankranti-details">
          <p className="sankranti-date">{item.date}</p>
          <p className="sankranti-name">{item.dayLabel}</p>
          <p className="sankranti-tithi">{item.tithi}</p>
          <p className="sankranti-deity">{item.deity}</p>
        </div>

        <div className="sankranti-timings">
          <p>Sunrise: {formatTime(item.sunrise, timeFormat)}</p>
          <p>Sunset: {formatTime(item.sunset, timeFormat)}</p>
          <p>{item.panchangNote}</p>
        </div>
      </div>
    ))}
  </div>
) : (
  <div className="san-detail-view">
    <button
      className="back-btn"
      onClick={() => setSelectedSankranti(null)}
    >
      ← Back
    </button>

    <h2>{selectedSankranti.dayLabel}</h2>

    <img
      src="https://static.toiimg.com/thumb/msid-117223167,width-400,resizemode-4/117223167.jpg"
      alt={selectedSankranti.dayLabel}
    />

    <p><strong>Date:</strong> {selectedSankranti.date}</p>
    <p><strong>Tithi:</strong> {selectedSankranti.tithi}</p>
    <p><strong>Deity:</strong> {selectedSankranti.deity}</p>

    {selectedSankranti.festivals?.length > 0 && (
      <>
        <p><strong>Festivals:</strong></p>
        <ul>
          {selectedSankranti.festivals.map((fest, idx) => (
            <li key={idx}>
              <strong>{fest}</strong>
              {festivalTooltips[fest] && (
                <p>{festivalTooltips[fest]}</p>
              )}
            </li>
          ))}
        </ul>
      </>
    )}

    <p><strong>Sunrise:</strong> {formatTime(selectedSankranti.sunrise, timeFormat)}</p>
    <p><strong>Sunset:</strong> {formatTime(selectedSankranti.sunset, timeFormat)}</p>

    {selectedSankranti.panchangNote && (
      <p><strong>Note:</strong> {selectedSankranti.panchangNote}</p>
    )}
  </div>
)}

        </div>

        <section className="sankranti-wrapper">
          <h1 className="sankranti-title">Sankranti Calendar</h1>
          <div className="sankranti-texts">
            <p>
              In Hindu calendar, there are total twelve Sankranti in a year. All twelve Sankranti can be divided into four categories which are known as <strong>Ayan</strong>, <strong>Vishuva</strong>, <strong>Vishnupadi</strong> and <strong>Shadshitimukhi Sankranti</strong>.
              <span className="popup-link" onClick={() => setPopupFestival("About 12 Sankranti")}> About 12 Sankranti</span> 
              provides detailed information on the categorization of Sankranti and their significance in Hindu Calendar.
            </p>

            <p>
              Among all Sankranti, 
              <span className="popup-link" onClick={() => setPopupFestival("Makar Sankranti")}> Makar Sankranti</span> 
              is the most significant one and it is observed throughout India.
              Due to the popularity of Makar Sankranti, it is just known as <strong>Sankranti</strong>.
              In South India, Makar Sankranti is observed for four days.
              <em>Makar Sankranti Calendar</em> lists all events and rituals which are followed during four days of Sankranti festivities.
            </p>

            <p>
              Sankranti days are considered good for <strong>charity activities</strong> and all <strong>auspicious ceremonies</strong> are avoided on the day of Sankranti(s).
            </p>
          </div>
        </section>
        <VratLinks />
      </div>
      <Footer />
      {popupFestival && (
  <div className="popup-overlay" onClick={() => setPopupFestival(null)}>
    <div className="popup-content" onClick={(e) => e.stopPropagation()}>
      <h2>{festivalDetails[popupFestival].name}</h2>
      <p><strong>Description:</strong> {festivalDetails[popupFestival].description}</p>
      <p><strong>Significance:</strong> {festivalDetails[popupFestival].significance}</p>
      <p><strong>Cultural Aspect:</strong> {festivalDetails[popupFestival].culturalAspect}</p>

      <button className="close-btn" onClick={() => setPopupFestival(null)}>Close</button>
    </div>
  </div>
)}

    </div>
  );
};

export default SankrantiDates;
